<template>
  <div class="dataTables_wrapper calc-controls-cargo-table" :style="wrapperStyle">
<!--    <span @click="populateFromClipboard" class="table-add float-right mb-3 mr-2"><a href="#" style="color: aquamarine"><mdb-icon icon="clipboard" class="fa-2x"/></a></span>-->
    <div class="d-flex flex-row justify-content-end">
      <mdb-btn-group>
        <mdb-btn
          rounded
          icon="plus"
          gradient="aqua"
          size="sm"
          class="mb-2"
          title="Add new cargo to packing"
          @click="cargoAdd"
        />
        <mdb-btn
          rounded
          icon="clipboard"
          gradient="aqua"
          size="sm"
          class="mb-2"
          title="Populate packing from text"
          @click="populateFromTextarea"
        />
      </mdb-btn-group>
    </div>
    <!-- Main table -->
    <tbl v-if="!scrollY" v-bind="tableProps" sm datatable>
      <tbl-head :color="headerColor" :textWhite="headerWhite">
        <tr>
          <th></th>
          <th
            v-for="(column, key) in columns"
            :key="key"
            :class="groupsFrom.includes(key) ? 'border-left' : ''"
          >
            {{column.label}}
          </th>
          <th class="border-left">Remove</th>
        </tr>
      </tbl-head>
      <tbl-body :class="dark ? 'white-text' : ''">
        <tr
          v-for="(cargo, cid) in cargoData"
          :key="`cargo-${cid}`"
          class="border-bottom"
        >
          <td :class="invalidCargo.includes(cid) ? 'text-warning' : 'text-success'">
            <mdb-icon :icon="invalidCargo.includes(cid) ? 'question-circle' : 'check'" />
          </td>
          <td
            v-for="(cargoField, index) in cargo"
            :key="`field-${index}`"
            :class="getCellClass(index, cid, cargoField.mu)"
          >
            <mdb-input
              class="m-0"
              :value="cargoField.value && Math.round(cargoField.value * Math.pow(10, 3)) / Math.pow(10, 3)"
              :placeholder="getCargoPlaceholder(cid, cargoField.mu)"
              :small="getCargoValidationMessage(cid, cargoField.mu)"
              @change="cargoUpdate($event, cid, cargoField.mu)"
              @focus="inputFocus(cid, cargoField.mu)"
              @blur="inputBlur()"
            />
          </td>
          <td class="border-left">
            <mdb-btn
              title="Remove cargo from packing"
              @click.native.prevent="cargoRemove(cid)"
              gradient="sunny-morning"
              size="sm"
              rounded
            ><mdb-icon icon="trash" /></mdb-btn>
          </td>
        </tr>
      </tbl-body>
    </tbl>
    <!-- Main table -->

  </div>
</template>

<script>
import {
  mdbTbl as Tbl,
  mdbTblHead as TblHead,
  mdbTblBody as TblBody,
  mdbIcon,
  mdbBtnGroup,
  mdbBtn,
  mdbInput,
  mdbSwitch
} from 'mdbvue'
import CalcControlsCargoTypesSelect from './CalcControlsCargoTypesSelect'

export default {
  name: 'CalcControlsCargoTable',
  props: {
    columns: {
      type: Array
    },
    cargoData: {
      type: Object
    },
    cargoPlaceholders: {
      type: Object
    },
    cargoValidationMessages: {
      type: Object
    },
    invalidCargo: {
      type: Array
    },
    highlightedInputs: {
      type: Object
    },
    wrongMuCodes: {
      type: Object
    },
    groupsFrom: {
      type: Array
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    borderless: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    headerColor: {
      type: String
    },
    headerWhite: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String
    },
    responsive: {
      type: Boolean,
      default: false
    },
    responsiveSm: {
      type: Boolean,
      default: false
    },
    responsiveMd: {
      type: Boolean,
      default: false
    },
    responsiveLg: {
      type: Boolean,
      default: false
    },
    responsiveXl: {
      type: Boolean,
      default: false
    },
    scrollY: {
      type: Boolean,
      defautl: false
    },
    entries: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      activePage: 0,
      pages: [],
      tableProps: {
        autoWidth: this.autoWidth,
        bordered: this.bordered,
        borderless: this.borderless,
        dark: this.dark,
        fixed: this.fixed,
        hover: this.hover,
        responsive: this.responsive,
        responsiveSm: this.repsonsiveSm,
        responsiveMd: this.repsonsiveMd,
        responsiveLg: this.responsiveLg,
        responsiveXl: this.responsiveXl,
        striped: this.striped,
        dtScrollY: this.scrollY
      },
      wrapperStyle: {
        maxWidth: this.maxWidth ? this.maxWidth : '100%',
        margin: '0 auto'
      }
    }
  },
  methods: {
    getCargoPlaceholder (cid, code) {
      const placeholder = this.cargoPlaceholders[cid] && this.cargoPlaceholders[cid][code]
      return placeholder ? placeholder.toString() : null
    },
    getCargoValidationMessage (cid, code) {
      const message = this.cargoValidationMessages[cid] && this.cargoValidationMessages[cid][code]
      return message ? message.toString() : null
    },
    cargoAdd () {
      this.$emit('cargo-add')
    },
    cargoRemove (cid) {
      this.$emit('cargo-remove', cid)
    },
    cargoUpdate (value, cid, code) {
      if (typeof value === 'string') {
        value = parseFloat(value.replace(/,/, '.'))
      }
      this.$emit(
        'cargo-update',
        { cid: cid, code: code, value: value }
      )
    },
    inputFocus (cid, code) {
      this.$emit('input-focus', { cid: cid, code: code })
    },
    inputBlur () {
      this.$emit('input-blur')
    },
    getCellClass (index, cid, code) {
      let classes = []
      if (this.groupsFrom.includes(index)) {
        classes.push('border-left')
      }
      if (this.highlightedInputs.cid === cid && this.highlightedInputs.codes.includes(code)) {
        classes.push('highlighted')
      }
      if (this.wrongMuCodes[cid] && this.wrongMuCodes[cid].includes(code)) {
        classes.push('wrong')
      }
      return classes.join(' ')
    },
    populateFromClipboard () {
      window.focus()
      navigator.clipboard.readText()
        .then(data => {
          this.populate(data)
        })
        .catch(error => {
          console.warn(error)
        })
    },
    populateFromTextarea () {
      this.$bus.$emit('modal-textarea', text => {
        this.populate(text)
      })
    },
    populate (text) {
      const BreakException = {}
      let data = text.split('\n').map(line => line.split('\t'))
      let valid = true
      try {
        data.forEach((line, lineIndex) => {
          if (line.length !== this.columns.length) {
            this.$notify.warn({
              title: `Error on line ${lineIndex + 1}`,
              message: `Please check columns number. Expected: ${this.columns.length}. Got: ${line.length}`,
              position: 'top right',
              timeOut: 10000,
              closeButton: true
            })
            throw BreakException
          }
          line.forEach((item, columnIndex) => {
            if (item !== '' && parseFloat(item.replace(/,/, '.')).toString() !== item.replace(/,/, '.')) {
              this.$notify.warn({
                title: `Error on line ${lineIndex + 1}`,
                message: `Column ${columnIndex + 1} has wrong number value: "${item}"`,
                position: 'top right',
                timeOut: 10000,
                closeButton: true
              })
              throw BreakException
            }
          })
        })
      } catch (e) {
        if (e !== BreakException) throw e
        valid = false
      }

      if (valid) {
        this.$emit('cargo-populated', data)
      }
    }
  },
  components: {
    Tbl,
    TblHead,
    TblBody,
    mdbIcon,
    mdbBtn,
    mdbBtnGroup,
    mdbInput,
    mdbSwitch,
    CalcControlsCargoTypesSelect
  }
}

</script>

<style lang="sass" scoped>
.dataTables-scrollBody
  display: block
  overflow-y: auto
  -ms-overflow-style: -ms-autohiding-scrollbar

.calc-controls-cargo-table td
  vertical-align: middle

</style>

<style lang="sass">
.md-form input::placeholder
  font-size: 80%
  font-style: italic
  font-weight: lighter
  color: darkcyan

td.highlighted
  background-color: lightcyan

td.wrong
  background-color: lightcoral

td.highlighted.wrong
  background: transparent repeating-linear-gradient(45deg, lightcyan, lightcyan 2px, lightcoral 2px, lightcoral 4px) !important
</style>



// WEBPACK FOOTER //
// src/components/CalcControlsCargoTable.vue